import React from 'react'
import PropTypes from 'prop-types'
import {coreButtonInputs, coreButtonPropTypes} from './cta.helper'
import {useDetermineRouteTypeAndUrl} from 'hec/hooks/useDetermineRouteTypeAndUrl'
import useFetchPageDataForCta from './useFetchPageDataForCta'
import {Button} from 'hec/components/cta'

const BuilderLink = ({
    variant,
    disabled,
    openInNewTab,
    children,
    attributes,
    clickFunction,
    scrollTargetId,
    isInternalLink,
    isRevShare,
    pageReference,
    queryParams,
    externalLinkReference,
    'data-testid': dataTestId
}) => {
    const {className: classNameAttribute, ...restAttributes} = attributes || {}

    const {
        pageRef,
        externalLinkRef,
        isLoading: isPageDataLoading,
        error: pageDataError
    } = useFetchPageDataForCta({
        isInternalLink,
        pageReference,
        externalLinkReference
    })

    const {routeType, url} = useDetermineRouteTypeAndUrl({
        clickFunction,
        isInternalLink,
        pageReference: pageRef,
        externalLinkReference: externalLinkRef
    })

    if (isPageDataLoading) {
        return null
    }

    if (pageDataError) {
        console.error('Error fetching page data for CTA: ', pageDataError)
        // Return a fallback link instead of null to prevent layout issues
        return (
            <Button
                ctaType="link"
                variant={variant}
                disabled={true}
                className={classNameAttribute}
                {...restAttributes}
                data-testid={dataTestId || 'link-Link-error'}
            >
                {children}
            </Button>
        )
    }

    return (
        <Button
            ctaType="link"
            variant={variant}
            disabled={disabled}
            openInNewTab={openInNewTab}
            clickFunction={clickFunction}
            scrollTargetId={scrollTargetId}
            isRevShare={isRevShare}
            routeType={routeType}
            url={url}
            queryParams={queryParams}
            className={classNameAttribute}
            {...restAttributes}
            data-testid={dataTestId || 'link-Link'}
        >
            {children}
        </Button>
    )
}

BuilderLink.propTypes = {
    className: PropTypes.string,
    variant: PropTypes.string,
    disabled: PropTypes.bool,
    ...coreButtonPropTypes
}

export const LinkDefinition = {
    component: BuilderLink,
    image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/link.svg',
    name: 'Link',
    override: true,
    noWrap: true,
    canHaveChildren: true,
    defaultChildren: [
        {
            '@type': '@builder.io/sdk:Element',
            component: {
                name: 'Text',
                options: {text: 'Click me'}
            }
        }
    ],
    childRequirements: {
        message: 'You can only put Text and Icons into Link component',
        query: {
            'component.name': {$in: ['Text', 'IconPicker', 'Heading']}
        }
    },
    inputs: [
        {
            name: 'variant',
            type: 'string',
            enum: ['normal', 'bold', 'navLink'],
            defaultValue: 'normal'
        },
        {
            name: 'disabled',
            type: 'boolean',
            defaultValue: false
        },
        ...coreButtonInputs
    ]
}
